module.exports = __webpack_public_path__ + "img/Bleachin_stock.43a50137.svg";